module.exports = __webpack_public_path__ + "img/error.6891d608.png";